import { createRouter, createWebHistory } from 'vue-router'
import IndexView from '../views/projects/ProjectIndexView.vue'
import NotFoundView from '../views/NotFoundView.vue'
import ProjectDetailView from '../views/projects/ProjectDetailView.vue'
import { authRoutes } from '@haskoning/vue-authentication-middleware'
import { storeToRefs } from 'pinia'
import { useAuthenticationStore } from '@/stores/authentication'
import { useProjectStore } from '@/stores/project'

export const INDEX_ROUTES = {
	NOT_FOUND: {
		name: 'not-found',
		path: '/:pathMatch(.*)*'
	},
	HOME: {
		name: 'home',
		path: '/',
		AUTH: {
			name: 'auth-login'
		}
	},
	PROJECT: {
		INDEX: {
			name: 'project-index',
			path: '/project-index'
		},
		DETAIL: {
			name: 'project-detail',
			path: '/project/:id'
		}
	}
}

const router = createRouter({
	history: createWebHistory(import.meta.env.BASE_URL),
	routes: [
		{
			path: INDEX_ROUTES.NOT_FOUND.path,
			name: INDEX_ROUTES.NOT_FOUND.name,
			component: NotFoundView
		},
		{
			path: INDEX_ROUTES.HOME.path,
			name: INDEX_ROUTES.HOME.name,
			redirect: {
				name: INDEX_ROUTES.HOME.AUTH.name
			}
		},
		authRoutes,
		{
			path: INDEX_ROUTES.PROJECT.INDEX.path,
			name: INDEX_ROUTES.PROJECT.INDEX.name,
			component: IndexView,
			beforeEnter: (to, from) => {
				const store = useProjectStore()
				store.resetAll()
				return true
			}
		},
		{
			path: INDEX_ROUTES.PROJECT.DETAIL.path,
			name: INDEX_ROUTES.PROJECT.DETAIL.name,
			component: ProjectDetailView
		}
	]
})

router.beforeEach(async (to) => {
	const authStore = useAuthenticationStore()
	const { user } = storeToRefs(authStore)

	if (!user?.value?.id) {
		const userResponse = await authStore.reAuthenticate()
		if (userResponse) {
			authStore.$patch({
				user: userResponse.user
			})
		}
	}
	if (typeof to.name !== 'string' || to.name?.startsWith('auth-')) {
		if (user.value) {
			return { name: INDEX_ROUTES.PROJECT.INDEX.name }
		}
		return true
	}
	// check auth and apply login redirect
	if (!user.value) {
		return { name: INDEX_ROUTES.HOME.AUTH.name }
	}
	return true
})

export default router
